"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLUGINS = exports.SYSTEM_FILTER = exports.CELL_SUMMARY = exports.APPLICATION = exports.BULK_UPDATE = exports.TEAM_SHARING = exports.POPUP = exports.GRID = exports.SYSTEM = void 0;
// constants used in Config
exports.SYSTEM = 'System';
exports.GRID = 'Grid';
exports.POPUP = 'Popup';
exports.TEAM_SHARING = 'TeamSharing';
exports.BULK_UPDATE = 'BulkUpdate';
exports.APPLICATION = 'Application';
exports.CELL_SUMMARY = 'CellSummary';
exports.SYSTEM_FILTER = 'SystemFilter';
exports.PLUGINS = 'Plugins';
